"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyBulkUpdateToDictsArray = exports.applyBulkUpdateToPrimitiveArray = void 0;
const cloneDeep_1 = __importDefault(require("lodash-es/cloneDeep"));
const applyBulkUpdateToPrimitiveArray = (value, update) => {
    value = value || [];
    const newValue = update.newValue || [];
    const oldValue = update.oldValue || [];
    // Handle empty array case
    if (value.length === 0) {
        return [...newValue];
    }
    const newValueSet = new Set(newValue);
    const oldValueSet = new Set(oldValue);
    // Check if this is just a reordering
    const isReordered = oldValue.length > 0 &&
        oldValue.length === value.length &&
        oldValue.every((item) => value.includes(item)) &&
        JSON.stringify(value) !== JSON.stringify(newValue);
    if (isReordered) {
        return [...newValue];
    }
    // Create a new array starting with current value
    const result = [...value];
    // Remove items that are in oldValue but not in newValue
    for (const item of oldValue) {
        if (!newValueSet.has(item)) {
            const index = result.indexOf(item);
            if (index !== -1) {
                result.splice(index, 1);
            }
        }
    }
    // Add items that are in newValue but not in oldValue
    for (const item of newValue) {
        if (!oldValueSet.has(item) && !result.includes(item)) {
            result.push(item);
        }
    }
    return result;
};
exports.applyBulkUpdateToPrimitiveArray = applyBulkUpdateToPrimitiveArray;
const applyBulkUpdateToDictsArray = (value, update, docKey) => {
    const updatedValue = (0, cloneDeep_1.default)(value || []);
    // Use safer approach for extracting values
    const valueKeyValues = updatedValue.map((item) => typeof item === "object" && item !== null ? item[docKey] : undefined);
    const addedItems = getListOfDictsDiff(update.oldValue || [], update.newValue || [], docKey);
    const deletedItems = getListOfDictsDiff(update.newValue || [], update.oldValue || [], docKey);
    for (const addedItem of addedItems) {
        if (typeof addedItem === "object" && addedItem !== null) {
            const addedKeyValue = addedItem[docKey];
            if (!valueKeyValues.includes(addedKeyValue)) {
                updatedValue.push(addedItem);
            }
        }
    }
    for (const deletedItem of deletedItems) {
        if (typeof deletedItem === "object" && deletedItem !== null) {
            const deletedKeyValue = deletedItem[docKey];
            if (valueKeyValues.includes(deletedKeyValue)) {
                const index = updatedValue.findIndex((item) => typeof item === "object" &&
                    item !== null &&
                    item[docKey] === deletedKeyValue);
                if (index !== -1) {
                    updatedValue.splice(index, 1);
                }
            }
        }
    }
    return updatedValue;
};
exports.applyBulkUpdateToDictsArray = applyBulkUpdateToDictsArray;
// Updated to work with general objects instead of DictArray
const getListOfDictsDiff = (items, otherItems, key) => {
    // Extract key values from valid objects
    const itemsKeyValues = items
        .filter((item) => typeof item === "object" && item !== null)
        .map((item) => item[key]);
    const diff = [];
    for (const otherItem of otherItems) {
        if (typeof otherItem === "object" && otherItem !== null) {
            if (!itemsKeyValues.includes(otherItem[key])) {
                diff.push(otherItem);
            }
        }
    }
    return diff;
};
